import { useTranslations } from 'src/provider/LocaleProvider'
import { SocialLabels } from 'src/types'
import Facebook from 'src/assets/Icons/facebook_13_11zon.avif'
import Instagram from 'src/assets/Icons/instagram_14_11zon.avif'
import TikTok from 'src/assets/Icons/tiktok_17_11zon.avif'
import LinkedIn from 'src/assets/Icons/linkedin_15_11zon.avif'
import Spotify from 'src/assets/Icons/spotify_16_11zon.avif'

export function SocialLabels() {
    const t = useTranslations()
    const Social: SocialLabels[] = [
        {
            id: 1,
            icon: Instagram,
            name: 'Instagram',
            link: `${t('social.instagram')}`,
        },
        // {
        //     id: 2,
        //     icon: WhatApp,
        //     name: 'WhatApp',
        //     link: 'https://wa.me/message/GEFEQ2AE5UMBK1',
        //     linkEs: 'https://wa.me/message/GEFEQ2AE5UMBK1',
        // },
        {
            id: 3,
            icon: LinkedIn,
            name: 'LinkedIn',
            link: `${t('social.linkedIn')}`,
        },
        {
            id: 4,
            icon: TikTok,
            name: 'TikTok',
            link: `${t('social.tikTok')}`,
        },
        {
            id: 5,
            icon: Spotify,
            name: 'Spotify',
            link: `${t('social.spotify')}`,
        },
        {
            id: 6,
            icon: Facebook,
            name: 'Facebook',
            link: `${t('social.facebook')}`,
        },
    ]
    return { Social }
}
